import { Controller } from "@hotwired/stimulus"

export default class AttributeToggleController extends Controller {
  static targets = ["element"]
  static values = {
    name: String,
    options: Array,
  }

  toggle() {
    if (this.optionsValue.length !== 2) {
      console.error(
        "There must be exactly 2 options for the AttributeToggleController. Received:",
        this.optionsValue
      )

      return
    }

    const elements = this.hasElementTarget
      ? this.elementTargets
      : [this.element]

    elements.forEach((element) => {
      this.#toggleAttributeForElement(element)
    })
  }

  toggleBooleanAttribute() {
    const elements = this.hasElementTarget
      ? this.elementTargets
      : [this.element]

    elements.forEach((element) => {
      element.toggleAttribute(this.nameValue)
    })
  }

  #toggleAttributeForElement(element) {
    const currentAttribute = element.getAttribute(this.nameValue)
    const newAttributeValue = this.optionsValue.find(
      (value) => value !== currentAttribute
    )

    element.setAttribute(this.nameValue, newAttributeValue)
  }
}
